module.exports = __webpack_public_path__ + "static/media/navMenuBG.5149c30b.jpg";